import { render, staticRenderFns } from "./numbers-badge-is-spam.vue?vue&type=template&id=4d2c043b&"
import script from "./numbers-badge-is-spam.vue?vue&type=script&lang=js&"
export * from "./numbers-badge-is-spam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports